export default "__VITE_ASSET__289f22ce__"